import React, { Component } from 'react'
import moment from 'moment';
import axios from 'axios';
import { APIURL } from '../../../hoc/AxiosSetting/axios';
import ToastInstance from '../../../hoc/NotificationSettings/ToastInstance';
import S3FileUpload from 'react-s3';
import swal from '@sweetalert/with-react';

export default class ViewAuditObservation extends Component {
    constructor(props) {
        super(props)
    
        this.state = {
            
             auditobservation: {
                orgCode : props.match.params.orgcode,
                auditobservationurl: "",
              
            },
              data: {},
              config: {
                bucketName: process.env.REACT_APP_BUCKET_NAME,
                dirName: process.env.REACT_APP_DIR_NAME /* optional */,
                region: process.env.REACT_APP_REGION,
                accessKeyId: process.env.REACT_APP_ACCESS_ID,
                secretAccessKey: process.env.REACT_APP_ACCESS_KEY,
            },
            buttonStatus: "none",
            downloadbuttonStatus: "none",
            uploadDocumentStatus: "none",
            uploadedDocumentStatus: "none",
            showFile: "Image",
            uploadedAuditObservationUrl: "",
            submitStatus: true,
            editStatus:false,
            showMessage:false,
            messageforvalidation :"none",
            uploadStatus: true,
            isLoading:false
            }
            this.viewAuditObservationUrlInput = React.createRef();

       
    }
    static getDerivedStateFromProps(props, state) {
        return { id: props.match.params.orgcode || 0 };
    }
    handleRoute = () => {
        window.location.href = "/"+localStorage.getItem("role")+'/auditobservation/' +this.state.auditobservation.orgCode;
    }
    componentDidMount(){
        const api = APIURL + '/api/rfq/get/orgdetails/' + this.state.auditobservation.orgCode
        axios.get(api, {headers: {
            'Authorization': 'Bearer ' + localStorage.getItem("token"),
         }})
        .then(res => {
          console.log("data ",res.data.response)
          this.setState({ data: res.data.response });
          if( res.data.response.auditPlanStatus)
          {
              this.setState({editStatus:true})
              if (this.state.data.auditobservationurl) {
                  console.log("if")
                  var uplodedFileName= this.state.data.auditobservationurl.split("/")
                  var uplodedFileNameToView = uplodedFileName[4]
                  this.setState({ uploadedAuditObservationUrl: this.state.data.auditobservationurl,uploadedFileNameToshow: uplodedFileNameToView})
                  this.setState({ uploadDocumentStatus: "none", uploadedDocumentStatus: "block",downloadbuttonStatus:"none" })
              }
              else if (! this.state.data.auditobservationurl) {
                  console.log("else if")
                  this.setState({ uploadDocumentStatus: "block", uploadedDocumentStatus: "none",downloadbuttonStatus:"block" })
              }
          } else 

          {
              console.log("else")
              this.setState({editStatus:false,message:"Need to Fill the Audit Plan Data",showMessage:true})
          } 
        })
        .catch(e=>{
            console.log("Something went Wrong", e)
            var string = JSON.stringify(e).split("/")[0]
            const regex = /401/g;
            const found = string.match(regex);

            console.log("found", found);
            if (found !== null) {
                window.location.href = "/signin"
                //alert("if")
                this.setState({isLoading:true})
            }
        })
    }
    generatePdf = () => {
        return axios.get(APIURL+'/api/generatepdf/get/auditobservationsheetstage1/' + this.state.auditobservation.orgCode, {
            responseType: 'arraybuffer',
            headers: {
                'Accept': 'application/pdf'
            }
        }
        ) 
            .then((response) => {
                const blob = new Blob(
                    [response.data],
                    { type: 'application/pdf' }
                )
                const link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = this.state.data.orgSerialNumber   + '- Audit Observation ' + `.pdf`
                link.click()
            })
    }
    checkFileExtension = (file) => {
        if (file) {
            if (file.match(/\.(jpg|jpeg|png|gif)$/)) {
                return "Image"
            } else if (file.match(/\.(pdf)$/)) {
                return 'pdf'
            }
        }
    }
    handleauditobservation = (event) => {
        event.preventDefault();
        let newArr = this.viewAuditObservationUrlInput.current.files[0];
        this.handleUpload(newArr);
    }
    handleUpload = (file) => {
        var file1 = Math.round((file.size / 1024));
        if(file1 <= 3072 ){
        S3FileUpload
            .uploadFile(file, this.state.config)
            .then(data => {
                var tempData =this.state.auditobservation;
                tempData.auditobservationurl = data.location
                var docType = this.checkFileExtension(data.location)
                var file= data.key.split("/")
                var fileName = file[1];
                this.setState({ auditobservationurl: tempData, 
                                showFile: docType ,
                                uploadStatus :false, 
                                messageforvalidation : "none",
                                fileToUpload : data.location,
                                filenameToview : fileName,
                                submitStatus : false
                            });
            })
            .catch(err => console.error(err))
        }
        else{
            this.setState({filenameToview : "",messageforvalidation : "block"})
        }
    };
    postData=()=>{
        var jsonRequest = {
            orgCode: this.state.auditobservation.orgCode,
            auditObservationUrl: this.state.auditobservation.auditobservationurl,
        }
        axios.patch(APIURL + "/api/rfq/patch/auditobservationurl", jsonRequest)
            .then((res) => {
                if (res.data.errorCode === 0) {
                    ToastInstance('Success', 'Audit Observation Data Uploded')
                }
                else {
                    ToastInstance('Error', 'Something Went Wrong')
                }
            })
            .catch(err => {
                ToastInstance('warning', 'Something Went Wrong..Please Try again')
            })

    }
    removeDoc = () => {
        var tempData = this.state.auditobservation;
        tempData.auditObservationUrl = ""
        this.setState({  
                        auditobservation: tempData ,
                        uploadStatus :true, 
                    });
    }
    removeUplodedDoc = (id) => {
        swal({
            title: "Are you sure?",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then((willDelete) => {
                if (willDelete) {
                    var jsonRequest ={
                                         "orgCode":this.state.auditobservation.orgCode,
                                     }
                  
                    axios.patch(APIURL + "/api/rfq/patch/deleteauditteamobservationurl",jsonRequest)
                    .then((res) => {
                        if (res.data.errorCode === 0) {
                           
                            this.setState({
                                uploadDocumentStatus: "block",
                                uploadedDocumentStatus: "none",
                                uploadProcessUrl: "",
                                uploadStatus : true ,
                                submitStatus: true,
                                uploadedAuditObservationUrl: "",
                                editStatus: true
                            })
                        }
                        else {
                            ToastInstance('Error', 'Something Went Wrong')
                        }
                    })
                    .catch(err => {
                        ToastInstance('warning', 'Something Went Wrong..Please Try again')
                    })

                }
            })
    }
    downloadUploadPdf=()=>{
        const link = document.createElement('a');
        console.log("link",link)
        link.href = this.state.fileToUpload
        window.open(link)
    }
    downloadSignedPdf = () => {
        const link = document.createElement('a');
        console.log("link",link)
        link.href = this.state.uploadedAuditObservationUrl
        window.open(link)
    }
    render() {
       
        const FileReviewProcess = () => (
            this.state.showFile === 'Image' ?
                <>
                    <img className="img-fluid" src={this.state.auditobservation.auditobservationurl} style={{ width: '80px', height: '80px' }}  onClick={()=>this.downloadUploadPdf()}/>
                    <p>{this.state.filenameToview}</p>
                    <span>
                        <h6 onClick={() => this.removeDoc('auditobaservationurl')} style={{ position: "relative", top: "-65px", marginLeft: "69px" }}><i className="fas fa-times"></i></h6>
                    </span>
                </>
                :
                this.state.showFile === 'pdf' ?
                     <div className="row">
                         <div className="col-sm-12">
                             <img className="img-fluid" src="/dist/img/pdf.png" style={{ width: '60px', height: '60px' }} onClick={() => this.downloadUploadPdf()} />

                             <span>
                                 <h6 onClick={() => this.removeDoc('auditobaservationurl')} style={{ position: "relative", top: "-65px", marginLeft: "69px" }}><i className="fas fa-times"></i></h6>
                             </span>
                         </div>
                         <div className="row">
                             <span>{this.state.filenameToview}</span>

                         </div>
                     </div>
                    :
                    <>
                        <input type='file' ref={this.viewAuditObservationUrlInput} onChange={this.handleauditobservation} />
                        <p style={{ fontSize: '10px', color: 'red' }}>Only Pdf and images are accpeted</p>
                    </>
        )
        if(this.state.isLoading){
            return(<h1>Loading</h1>)
        }
        return (
            <div>
            <div className="content-wrapper">
                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                        {
                                this.state.showMessage  ?

                                    <div className="text-center"><p style={{fontSize:"25Px" ,color:"red"}}>{this.state.message}</p></div>
                                :
                                    null
                            }
                            <div className="col-sm-12">
                                <div className="card-body" style={{ paddingLeft: "50px" }}>
                                    <div className="row">
                                        <div className="col-sm-12">
                                                <div className="row">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Organization</label>
                                                    <div className="col-sm-9">
                                                        <p>{this.state.data.orgName}</p>
                                                    </div>
                                                    </div>
                                                    <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize" >Address</label>
                                                    <div className="col-sm-9">
                                                        <p>{this.state.data.address}</p>
                                                    </div>
                                                    </div>
                                                    <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Number of sites</label>
                                                    <div className="col-sm-3">
                                                       
                                                        <p>{this.state.data.nosites}</p>
                                                    </div>
                                                </div>

                                                <div className="row mt-4">
                                                   

                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Scope of certification</label>
                                                    <div className="col-sm-9">
                                                        {/* <p>:</p> */}
                                                        <p>{this.state.data.scopeofcertification}</p>
                                                    </div>
                                                </div>

                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Compliance Standard</label>
                                                    <div className="col-sm-3">
                                                        <p>{this.state.data.typeOfCertification}</p>
                                                    </div>
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Date of Audit</label>
                                                    <div className="col-sm-3">
                                                        <p>{moment(this.state.data.dateofaudit).format("DD-MMM-YYYY")}</p>
                                                    </div>
                                                </div>

                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Clearance date</label>
                                                    <div className="col-sm-3">
                                                        <p>{moment(this.state.data.clearancedate).format("DD-MMM-YYYY")}</p>
                                                    </div>
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Lead Auditor/Auditor</label>
                                                    <div className="col-sm-3">
                                                        <p>{this.state.data.teamleaderName}</p>
                                                    </div>

                                                    
                                                </div>

                                                <div className="row mt-4">
                                                 
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Objectives of Stage 1 audit</label>
                                                    <div className="col-sm-9">
                                                        <p>{this.state.data.objectivestage}</p>
                                                    </div>
                                                </div>
                                             


                                                <div className="row mt-4">
                                                    <div className="headingcolor hrstyle">
                                                        <h5>The first stage of the audit has taken place to confirm that the organisation has:</h5>
                                                    </div>
                                                    </div>
                                                    
                                                    <div className="row mt-2">
                                                        <div className="row">
                                                            <label htmlFor="staticEmail" className="col-sm-7 mt-3 labelsize">A sufficient understanding with regard to the requirements of ISO 9001:2015 </label>
                                                            <div className="col-sm-4 mt-3">
                                                                <p>{this.state.data.requirementsiso}</p>
                                                            </div>

                                                            <label htmlFor="staticEmail" className="col-sm-7 mt-3 labelsize">Documented information as required by the standard ISO 9001:2015</label>
                                                            <div className="col-sm-4 mt-3">
                                                                <p>{this.state.data.standardiso}</p>
                                                            </div>

                                                            <label htmlFor="staticEmail" className="col-sm-7 mt-3 labelsize">Suitable premises for the provision of the products/service listed in the scope</label>
                                                            <div className="col-sm-4 mt-3">
                                                                <p>{this.state.data.listedscope}</p>
                                                            </div>

                                                            <label htmlFor="staticEmail" className="col-sm-7 mt-3 labelsize">Employed suitable expertise in preparing the Quality Management System</label>
                                                            <div className="col-sm-4 mt-3">
                                                                <p>{this.state.data.qualitymanagement}</p>
                                                            </div>

                                                            <label htmlFor="staticEmail" className="col-sm-7 mt-3 labelsize">Identified necessary statutory and regulatory and compliance requirements.</label>
                                                            <div className="col-sm-4 mt-3">
                                                                <p>{this.state.data.compliancerequirements}</p>
                                                            </div>

                                                            <label htmlFor="staticEmail" className="col-sm-7 mt-3 labelsize">An effective management review and internal audit system in place</label>
                                                            <div className="col-sm-4 mt-3">
                                                                <p>{this.state.data.effectivemangement}</p>
                                                            </div>

                                                            <label htmlFor="staticEmail" className="col-sm-7 mt-3 labelsize">Appropriate pre-requisite programmes for stage 2 audit in place</label>
                                                            <div className="col-sm-4 mt-3">
                                                                <p>{this.state.data.prerequisiteprogrammes}</p>
                                                            </div>
                                                        </div>
                                                        <hr style={{marginTop:"1%"}}/>

                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-3 labelsize">Clients’ location & site-specific conditions</label>
                                                            <div className="col-sm-9">
                                                                <p>{this.state.data.clientlocation}</p>
                                                            </div>
                                                            </div>
                                                            <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-3 labelsize">Statutory & Regulatory aspects (quality, environmental & legal)</label>
                                                            <div className="col-sm-9">
                                                                <p>{this.state.data.regulatoryaspects}</p>
                                                            </div>
                                                        </div>
                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-3 labelsize">Clients’ status and understanding regarding requirements of the standard</label>
                                                            <div className="col-sm-9">
                                                                <p>{this.state.data.clientStatus}</p>
                                                            </div>
                                                        </div>

                                                        
                                                        <div className="row mt-4">
                                                            <div className="headingcolor hrstyle">
                                                                <h5>Organization structure:</h5>
                                                            </div>
                                                            </div>
                                                           
                                                            <div className="row">
                                                                <div className="row mt-2">
                                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Process Details </label>
                                                                    <div className="col-sm-3">
                                                                        <p>{this.state.data.processdetails}</p>
                                                                    </div>

                                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Repetitive Process </label>
                                                                    <div className="col-sm-3">
                                                                        <p>{this.state.data.repetitiveprocess}</p>
                                                                    </div>
                                                                </div>

                                                                <div className="row mt-4">
                                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">No. of employees </label>
                                                                    <div className="col-sm-3">
                                                                        <p>{this.state.data.total}</p>
                                                                    </div>

                                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">No. of shifts</label>
                                                                    <div className="col-sm-3">
                                                                        <p>{this.state.data.noOfShifts}</p>
                                                                    </div>

                                                                </div>

                                                                <div className="row mt-4">
                                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Effective Number of Employees to Audited </label>
                                                                    <div className="col-sm-9">
                                                                        <p>{this.state.data.effectivenumber}</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                       

                                                        <div className="row">
                                                          

                                                            <label htmlFor="staticEmail" className="col-sm-12 labelsize">Scope of certification & ANZ-SIC code/ NACE code</label>
                                                            <div className="col-sm-12">
                                                                <p className="mt-8">{this.state.data.nabcbcodeName}</p>
                                                            </div>
                                                        </div>

                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-12 labelsize">7.5 Related documented information include
                                                                a.Documented information as required by standard
                                                                b.Quality Policy
                                                                c.Quality Objectives</label>
                                                            <div className="col-sm-12">
                                                                <p className="mt-4">{this.state.data.relateddocuments}</p>
                                                            </div>
                                                            </div>
                                                            <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-12 labelsize">Control of externally provided Processes, Products & Services and control there of </label>
                                                            <div className="col-sm-12">
                                                                <p>{this.state.data.controlofprocess}</p>
                                                            </div>
                                                        </div>

                                                        <div className="row mt-4">
                                                            <div className="headingcolor hrstyle">
                                                                <h5>Internal audit conducted:</h5>
                                                            </div>
                                                            </div>
                                                          
                                                            <div className="row">
                                                                <div className="row mt-4">
                                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Date of last IA </label>
                                                                    <div className="col-sm-3">
                                                                        <p>{moment(this.state.data.dateia).format("DD-MMM-YYYY")}</p>
                                                                    </div>

                                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Frequency</label>
                                                                    <div className="col-sm-3">
                                                                        <p>{this.state.data.frequency}</p>
                                                                    </div>
                                                                </div>

                                                                <div className="row mt-4">
                                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Non conformity(if any)</label>
                                                                    <div className="col-sm-3">
                                                                        <p>{this.state.data.nonconformity}</p>
                                                                    </div>

                                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Status of NC closing</label>
                                                                    <div className="col-sm-3">
                                                                        <p>{this.state.data.statusncclosing}</p>
                                                                    </div>

                                                                </div>

                                                                <div className="row mt-4">
                                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Previous Internal Audit Conducted on </label>
                                                                    <div className="col-sm-9">
                                                                        <p>{
                                                                            this.state.data.internalaudit=== null?
                                                                            "NA"
                                                                            :  
                                                                            moment(this.state.data.internalaudit).format("DD-MMM-YYYY") 
                                                                        }
                                                                        
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            
                                                        </div>


                                                        <div className="row mt-4">
                                                            <div className="headingcolor hrstyle">
                                                                <h5>Management Review conducted(MRM):</h5>
                                                            </div>
                                                            </div>
                                                           
                                                            <div className="row">
                                                                <div className="row mt-4">
                                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Date</label>
                                                                    <div className="col-sm-3">
                                                                        <p>{moment(this.state.data.managementdate).format("DD-MMM-YYYY")}</p>
                                                                    </div>

                                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Frequency</label>
                                                                    <div className="col-sm-3">
                                                                        <p>{this.state.data.managementfrequency}</p>
                                                                    </div>
                                                                </div>

                                                                <div className="row mt-4">
                                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Attended by</label>
                                                                    <div className="col-sm-3">
                                                                        <p>{this.state.data.attendedby}</p>
                                                                    </div>

                                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Previous MRM Conducted on</label>
                                                                    <div className="col-sm-3">
                                                                        <p>{ this.state.data.mrmconducted === null ? "-" : moment(this.state.data.mrmconducted).format("DD-MMM-YYYY") || "NA"}</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                       
                                                    

                                                        <div className="row mt-4">
                                                            <div className="headingcolor hrstyle">
                                                                <h5>Verification of Design & Development</h5>
                                                            </div>
                                                            </div>
                                                          
                                                            <div className="row">
                                                                <div className="row mt-4">
                                                                    <label htmlFor="staticEmail" className="col-sm-12 labelsize">Check the customer requirements as per the given scope</label>
                                                                    <div className="col-sm-12">
                                                                        <p>{this.state.data.customerrequirements}</p>
                                                                    </div>
                                                                </div>
                                                                <div className="row mt-4">
                                                                    <label htmlFor="staticEmail" className="col-sm-12 labelsize">Product / Service specification (provided by customer (fully or partially )</label>
                                                                    <div className="col-sm-12">
                                                                        <p>{this.state.data.fullyorpartially}</p>
                                                                    </div>
                                                                </div>

                                                                <div className="row mt-4">
                                                                    <label htmlFor="staticEmail" className="col-sm-12 labelsize">Who decides Material specification / properties , product parameter s and Inspection & testing parameters (where it is appropriate)</label>
                                                                    <div className="col-sm-12">
                                                                        <p>{this.state.data.materialspecification}</p>
                                                                    </div>
                                                                    </div>
                                                                    <div className="row mt-4">
                                                                    <label htmlFor="staticEmail" className="col-sm-12 labelsize">Look for support process for product manufacturing (such as tool design, bought out / child part in case of assembly) </label>
                                                                    <div className="col-sm-12">
                                                                        <p>{this.state.data.productmanufacturing}</p>
                                                                    </div>

                                                                </div>

                                                                <div className="row mt-4">
                                                                    <label htmlFor="staticEmail" className="col-sm-12 labelsize">Comment by auditor -  Design applicable YES / NO </label>
                                                                    <div className="col-sm-12">
                                                                        <p>{this.state.data.commentbyauditor}</p>
                                                                    </div>
                                                                    </div>
                                                                    <div className="row mt-4">
                                                                    <label htmlFor="staticEmail" className="col-sm-12 labelsize">Justification </label>
                                                                    <div className="col-sm-12 mb-4">
                                                                        <p>{this.state.data.justification}</p>
                                                                    </div>
                                                                    
                                                                </div>
                                                            </div>
                                                       

                                                        

                                                        <div className="row">
                                                            <label htmlFor="staticEmail" className="col-sm-7 labelsize">8.5.1 Applicability for Validation of processes and records there of</label>
                                                            <div className="col-sm-4">
                                                                <p>{this.state.data.validationofprocesses}</p>
                                                            </div>
                                                        </div>

                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-7 labelsize">REMARK:The objectives of Stage 1 Audit have been achieved (tick )</label>
                                                            <div className="col-sm-2">
                                                                <p>{this.state.data.remarkofstage}</p>
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <div className="row mt-4">
                                                                    <hr className="mt-4" />
                                                                    <div className="col-sm-6 text-dark ">
                                                                        <h5>Download Audit Observation</h5>
                                                                    </div>
                                                                    <div className="col-sm-4"/>
                                                                    
                                                                    <button className="btn btn-primary btn-sm col-sm-2 mb-2 ml-2" onClick={() => this.generatePdf()}>Download</button>
                                                                    
                                                                    <hr />
                                                                </div>
                                                        </div>
                                                        {
                                                       localStorage.getItem("userRole") === 'Management' || localStorage.getItem("userRole") === 'Accounts' ? 
                                                      ""
                                                      :
                                                    <div style={{ display: this.state.uploadDocumentStatus }}>
                                                        <div className="row mt-4">
                                                            <hr className="mt-4" />
                                                            <div className="col-sm-6 text-dark ">
                                                                <h5>Upload Audit Observation </h5>
                                                            </div>
                                                            <hr />
                                                            <div className="row mt-5" >
                                                                <div className="col-sm-4"><label htmlFor="staticEmail" className="labelsize">Upload Stage1 Audit Observation </label></div>
                                                                <div className="col-sm-6">
                                                                <p style={{color:"red" ,display:this.state.messageforvalidation}}>Please Select Size Which is less than 3 MB</p>
                                                                    {
                                                                        this.state.auditobservation.auditobservationurl !== "" ?
                                                                            <FileReviewProcess />
                                                                            :
                                                                            <>
                                                                                <input type='file' ref={this.viewAuditObservationUrlInput} onChange={this.handleauditobservation} />
                                                                                <br></br>

                                                                            </>
                                                                    }
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-sm-6" />
                                                                <div className="col-sm-4" />
                                                                <button type="button" className="btn btn-sm btn-success col-sm-2 mb-2 mr-2" onClick={() => this.postData()} disabled={this.state.submitStatus}>Upload</button>
                                                               

                                                            </div>

                                                        </div>
                                                        
                                                    </div>
                                                    }
                                                    <div style={{ display: this.state.uploadedDocumentStatus }} >
                                                    <div className="row mt-5" >
                                                        <hr className="mt-4" />
                                                        <div className="col-sm-6 text-dark ">
                                                            <h5>Uploaded Stage1 Audit Observation</h5>
                                                        </div>
                                                        <hr />
                                                        <div className="col-sm-4">

                                                            <label className="mt-4 labelsize">
                                                                Uploaded Stage1 Audit Observation
                                                            </label>

                                                        </div>
                                                        <div className="col-sm-6">
                                                            {
                                                                this.state.uploadedAuditObservationUrl.match(/\.(jpg|jpeg|png|gif)$/) ?
                                                                    <>
                                                                        <img className="img-fluid" src={this.state.uploadedAuditObservationUrl} style={{ width: '80px', height: '80px' }} onClick={()=>this.downloadSignedPdf()}/>
                                                                        <p>{this.state.uploadedFileNameToshow}</p>
                                                                        {
                                                                        localStorage.getItem("userRole") === 'Management' || localStorage.getItem("userRole") === 'Accounts'?
                                                                        ""
                                                                        :
                                                                        <span>
                                                                            <h6 onClick={() => this.removeUplodedDoc('processUrl')} style={{ position: "relative", top: "-65px", marginLeft: "69px" }}><i className="fas fa-times"></i></h6>
                                                                        </span>
                                                                        }
                                                                    </>
                                                                    :
                                                                    this.state.uploadedAuditObservationUrl.match(/\.(pdf)$/) ?
                                                                        <>
                                                                            <img className="img-fluid mt-3" src="/dist/img/pdf.png" style={{ width: '60px', height: '60px' }}  onClick={()=>this.downloadSignedPdf()}/>
                                                                           
                                                                           { 
                                                                             localStorage.getItem("userRole") === 'Management' || localStorage.getItem("userRole") === 'Accounts'?
                                                                             ""
                                                                             :
                                                                                <span>
                                                                                    <h6 onClick={() => this.removeUplodedDoc('processUrl')} style={{ position: "relative", top: "-65px", marginLeft: "69px" }}><i className="fas fa-times"></i></h6>
                                                                                </span>
                                                                            }
                                                                             <p>{this.state.uploadedFileNameToshow}</p>
                                                                            </>

                                                                        :
                                                                        ""
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                                {
                                                      localStorage.getItem("userRole") === 'Management' || localStorage.getItem("userRole") === 'Accounts' ? 
                                                      
                                                      !this.state.uploadedAuditObservationUrl  ?
                                                      <>
                                                     
                                                     
                                                         <div className="col-sm-6">The Signed Pdf is not yet uploaded</div>
                                                             
                                                               </> 
                                                                
                                                                :
                                                                ""
                                                                :
                                                                ""

                                                }
                                                    </div>
                                               
                                           
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            { 
                    localStorage.getItem("userRole")==="Management" || localStorage.getItem("userRole")==="Accounts"  || localStorage.getItem("userRole")==="Executive(Support)"?
                    ""
                    :
           
            <div className="card-footer">
                                <div className="row">
                                <div className="col-sm-10"></div>
                                <div className="col-sm-2">
                                {
                                this.state.editStatus ?
                                ! this.state.uploadedAuditObservationUrl ?
                                    <button className="btn btn-primary float-right"  onClick={() =>  this.handleRoute() }>Edit</button>
                                    : 
                                    <div></div>
                                    :"" 
                                }
                                 </div> 
                            </div>
                            </div> 
    }

        </div>
        )
    }
}
